import FileRow from "components/file-components/file-row";
import ReadMoreText from "components/ReadMoreText";
import { getAvatarBgColor, getInitials } from "utils/helper";

interface FeedbackCommentProps {
  name: string;
  role: string;
  commentedDate: string;
  comment: string;
  status?: string;
  file?: File[];
  fileRowProps?: any;
}

function FeedbackComment({
  name,
  role,
  commentedDate,
  comment,
  file,
  status,
  fileRowProps,
}: FeedbackCommentProps) {
  const initials = getInitials(name);
  const bgColor = getAvatarBgColor(name); // Get a consistent color based on the name

  return (
    <div className="items-start bg-gray-50 p-4 rounded-lg border border-gray-200">
      <div className="flex">
        {/* Avatar with Initials */}
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-semibold flex-shrink-0 mr-3 ${bgColor}`}
        >
          {initials}
        </div>

        <div>
          <div className="font-semibold text-gray-800">{name}</div>
          <div className="text-sm text-gray-500">{role}</div>
          <div className="flex gap-1">
            <div className="text-xs text-gray-700 mb-2 font-semibold">
              Date:
            </div>
            <div className="text-xs text-gray-500 mb-2">{commentedDate}</div>
          </div>
        </div>
        {status && (
          <div className="ml-auto bg-gray-200 h-fit px-2 py-1 font-semibold text-[12px] text-gray-800 rounded-lg">
            <p>{status}</p>
          </div>
        )}
      </div>
      <p className="text-gray-700 text-sm ml-12">
        <ReadMoreText text={comment} maxLines={3} />
      </p>

      <div className="flex flex-col px-12 mt-4">
        {file &&
          file.length > 0 &&
          file?.map((file, index) => (
            <FileRow file={file} {...fileRowProps} key={index} />
          ))}
      </div>
    </div>
  );
}

export default FeedbackComment;
